<script setup lang="ts">
import { computed } from "vue";

import Template from "~/components/dumb/Template.vue";
import Tooltip from "~/components/dumb/Tooltip.vue";
import { CheckIcon } from "~/icons";
import { EditorMode } from "~/shared/enums";
import type { Property } from "~/shared/types";

const props = defineProps<{
  value: boolean;
  property?: Property;
  editorMode: EditorMode;
}>();

const isBoardMode = computed(() => props.editorMode === EditorMode.BOARD);
</script>

<template>
  <component :is="isBoardMode ? Tooltip : Template" v-if="value" :text="isBoardMode ? property?.title : undefined">
    <div class="flex icon-md items-center justify-center rounded-sm border border-oncolor text-md">
      <CheckIcon class="icon-xs" />
    </div>
  </component>
</template>
